/* 🤖 this file was generated by svg-to-ts */
export const matIconLinkedCamera: {
  name: 'linked-camera';
  data: string;
} = {
  name: 'linked-camera',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 9v11H4V8h4.05l1.83-2H15V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-2zm.67-1.01H22A6.003 6.003 0 0 0 16 2v1.33c2.58 0 4.66 2.08 4.67 4.66zm-2.67 0h1.33A3.327 3.327 0 0 0 16 4.67V6c1.11 0 1.99.89 2 1.99zM7 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm8 0c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.34 3 3z"/></svg>`
};
